import Image from '@react/shared/components/Image';
import { ReviewerBody } from '@react/shared/types/usePrefetch';
import cx from 'classnames';
import { Chevron } from 'sly/icons';
import { getReviewerPath } from 'sly/resourceCenter/helpers';
import { Link } from 'sly/system';

interface ReviewerCardProps {
  reviewer: ReviewerBody;
  hideLink?: boolean;
}

export default function ReviewerCard({
  reviewer,
  hideLink,
}: ReviewerCardProps) {
  const { img, firstName, fullName, shortDescription, slug } = reviewer;
  const reviewerPagePath = getReviewerPath(slug);
  return (
    <div
      className={cx('flex flex-col gap-l md:flex-row', 'mb-xxs lg:gap-xxl')}
      data-tp-id='gen-div-4041b20e-2b79-49f2-a24c-92db1c8aad54'
    >
      <div
        className='flex flex-col items-center text-center'
        data-tp-id='gen-div-a1deb11f-945b-4cec-8b98-96ef839cabb6'
      >
        <div
          className=' aspect-h-1 relative h-[15rem] w-[15rem] overflow-hidden rounded-[50%]'
          data-tp-id='gen-div-5c2ee0bc-f1cb-4582-ae08-fe63ac801910'
        >
          <Link
            to={reviewerPagePath}
            data-tp-id='gen-Link-b99c3053-ef94-45c7-91eb-d67cb1d69bfe'
          >
            <Image
              path={img?.path}
              alt={img?.alternativeText}
              objectFit='cover'
              layout='fill'
              data-tp-id='gen-Image-e29c771c-d61d-4c4c-8367-75223dd48737'
            />
          </Link>
        </div>
      </div>
      <div data-tp-id='gen-div-2f700e3e-b672-4d40-9383-ba6e34aa3fa0'>
        <Link
          to={reviewerPagePath}
          className='!text-slate-base'
          data-tp-id='gen-Link-195c5ee0-2fb2-4ce7-956b-35dffb416969'
        >
          <div
            className='font-t-l pb-6'
            data-tp-id='gen-div-b747b3ca-7349-42d0-805e-0262828a0f77'
          >
            {fullName}
          </div>
        </Link>
        <div
          className='dynamic-editor !font-b-m md:mr-16'
          dangerouslySetInnerHTML={{
            __html: shortDescription,
          }}
          data-tp-id='gen-div-ac0df881-a0b6-42d1-affc-ef8b02624471'
        />
        {hideLink ? null : (
          <div
            className='mt-6 flex'
            data-tp-id='gen-div-5e4df55e-a503-445a-9e90-e7d56e38e57d'
          >
            <Link
              className='font-t-xs-azo underline'
              to={reviewerPagePath}
              data-tp-id='gen-Link-b1de3296-aac2-498a-9e42-c2a3b2ff1290'
            >
              <div
                className='flex'
                data-tp-id='gen-div-c4c3d734-f4fa-4343-af13-0d888a9efbc4'
              >
                <div data-tp-id='gen-div-3dfbabb9-4958-4a22-b739-ec7942f76fa8'>
                  Learn more about {firstName}
                </div>
                <div
                  className='flex flex-col justify-center'
                  data-tp-id='gen-div-8576bd53-9b33-4548-bda4-7f6ba62a7a19'
                >
                  <Chevron className='rotate-90' />
                </div>
              </div>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
